/**
 * @fileoverview
 * Calculate UI zoom factor based on screen size.
 *
 * Why?
 * Original Figma designs were created with the reference screen
 * size 375x667px (iPhone SE). Player often renders in area smaller
 * than that - inside another webpage - so the UI looks too big.
 * The solution is to zoom UI interface between <0.75, 1> if available
 * real estate is smaller than reference size.
 *
 * Why 375x375px as a reference?
 * <fw-storyblock /> uses 75vh height as default. We decided to use
 * 375x375px as a reference size to not zoom in portrait orientation where
 * default height applies.
 *
 * Why zoom and not scale?
 * CSS zoom works differently as transform:scale. Zoom applies to content only
 * while keeping the positioning. Scale applies to the whole element.
 *
 * How is this used?
 * `uiZoom` is stored in Player3's state and applied by `--ui-zoom` CSS variable.
 *
 * @param width
 * @param height
 * @returns
 */
export const calculateUiZoom = (width, height) => {
    const referenceWidth = 375;
    const referenceHeight = 375;
    return Math.min(Math.min(1, Math.max(0.75, width / referenceWidth)), Math.min(1, Math.max(0.75, height / referenceHeight)));
};
